import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

const opts = {
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#607d8b',
        secondary: '#1565c0'
      }
    }
  }
}

export default new Vuetify(opts)
